import Action from './action';
import { IDTypeOptions } from '../../../common/enum';

import { IOption } from '../../../components/Select';
interface IAction {
    certificateType: IOption,
    certificateNumber: string,
    errorText?: string,
}

const initialState = {
    certificateType: IDTypeOptions[0],
    certificateNumber: '',
    errorText: ''
};

export default (state = initialState, action: {type: string, playload: string | IAction}) => {
    switch (action.type) {
        case Action.UPDATE_CERTIFICATE_TYPE: {
            return {
                ...state,
                certificateType: action.playload,
            }
        }
        case Action.UPDATE_CERTIFICATE_NUMBER: {
            return {
                ...state,
                certificateNumber: action.playload,
            }
        }
        case Action.UPDATE_CERTIFICATE_GROUP: {
            return {
                ...state,
                certificateType: (action.playload as IAction).certificateType,
                certificateNumber: (action.playload as IAction).certificateNumber
            }
        }
        case Action.UPDATE_CERTIFICATE_ERROR_TEXT: {
            try {
                action.playload && (window as any).mailStats.show('certificate_number_error', { errorText: action.playload })
            } catch(e) {}
            return {
                ...state,
                errorText: action.playload
            }
        }
        default: return state;
    }
}
